module.exports = __webpack_public_path__ + "static/img/lineback.3f2b55f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lineback.png
// module id = jKbo
// module chunks = 1